import {
    ArrayModel,
    assignModelOptions,
    CompositeModel,
    ConfigConstants,
    CrmCodeModel,
    CustomInjector,
    DisplayDecorator,
    DropdownModel,
    MultilineTextModel,
    ODataCrmCodeOutModel,
    ODataObject,
    TextModel,
    ValueHelperModel,
    ValueHelperService,
} from '@evorait/pace-core';
import * as _ from 'lodash';

const MAX_CHAR_LENGTH = 40;
const MIN_CHAR_LENGTH = 10;
const ROWS = 3;

export class ConfirmationReasonMissingProtocolModel extends CompositeModel {
    public reasonForMissingProtocols: DropdownModel<TextModel>;
    public reasonSelected: TextModel | undefined;
    public displayOtherReasonTextField = false;
    public otherReasonDescription: MultilineTextModel;

    public constructor(public readonly notificationType: ConfigConstants.NotificationTypes) {
        super('ConfirmationReasonMissingProtocolModel');

        const injector = CustomInjector.getInjector();
        const valueHelperService = injector.get(ValueHelperService);

        const valueHelpers: ValueHelperModel[] = valueHelperService.getReasonsMissingProtocolsByCode(
            this.notificationType,
        );

        const entries = this.populateDropdown(valueHelpers);

        // If the array of possible reasons is empty then don't display dropdown nor otherReason input field.
        // Just make the Apply and Open Form visible in the modal
        if (entries.length > 0) {
            this.reasonForMissingProtocols = new DropdownModel<TextModel>('MissingProtocols', entries);
            this.reasonForMissingProtocols = assignModelOptions(this.reasonForMissingProtocols, {
                ...this.reasonForMissingProtocols.options,
                required: true,
                autoSelect: true,
            });

            this.otherReasonDescription = new MultilineTextModel('OtherReasonDescription');

            this.otherReasonDescription = assignModelOptions(this.otherReasonDescription, {
                ...this.otherReasonDescription.options,
                required: true,
                rows: ROWS,
                maxLength: MAX_CHAR_LENGTH,
                minLength: MIN_CHAR_LENGTH,
            });
        }
    }

    public populateDropdown(valueHelpers: ValueHelperModel[]): Array<DisplayDecorator<TextModel>> {
        const options: Array<DisplayDecorator<TextModel>> = [];
        valueHelpers.forEach((valueHelper) => {
            const textModel = new TextModel(valueHelper.descText, valueHelper.code);
            const decorator = new DisplayDecorator<TextModel>(valueHelper.descText, textModel);

            options.push(decorator);
        });

        return options;
    }

    public onReasonSelected(): void {
        this.reasonSelected = this.reasonForMissingProtocols.selectedEntry.model;
        this.displayOtherReasonTextField =
            this.reasonSelected.value === ConfigConstants.CrmMissingProtocolReasonCodes.OTHR;
    }

    public getOutModel(): ODataConfirmationReasonMissingProtocolsOutModel {
        const outModel = <ODataConfirmationReasonMissingProtocolsOutModel>super.getOutModel();
        const crmCodes = <ArrayModel<CrmCodeModel>>this.set(new ArrayModel<CrmCodeModel>('CrmCodesSet'));
        if (this.reasonSelected) {
            crmCodes.addModel(
                new CrmCodeModel({
                    codeType: ConfigConstants.confirmationMissingProtocolCodeType,
                    codeGroup: ConfigConstants.confirmationMissingProtocolCodeGroup,
                    code: this.reasonSelected.value,
                    codeText:
                        this.reasonSelected.value === ConfigConstants.CrmMissingProtocolReasonCodes.OTHR
                            ? this.otherReasonDescription.value
                            : this.reasonForMissingProtocols.selectedEntry.model.name,
                }),
            );
        }

        _.merge(outModel, crmCodes.getOutModel());
        return outModel;
    }
}

export interface ODataConfirmationReasonMissingProtocolsOutModel extends ODataObject {
    CrmCodesSet: ODataCrmCodeOutModel[];
}
